<div class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center" style="width: 100%;">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24">
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card " style="border-color: transparent">
            <!--<img src="{{urlBanner}}" alt="Logo-Norm35" class="centradoIMG ">-->
        </div>
        <!-- / CONTENT -->

    </div>
    <!-- / CONTENT CARD -->
    <!-- CONTENT -->
    <div class="content-card" style="margin-top: 2%; margin-left: 2%; margin-right: 5%; padding-top: 5%;">
        <!--{{ 'WIZARD.PATRON.0.SECCION' | translate}}-->
        <div fxLayout="column" fxLayoutAlign="space-evenly start">
            <h3 style="font-weight: bold;">{{ 'WIZARD.TIMELINE.TIMELINE' | translate}}</h3>


            <div fxFlex="50" class="">
                <mat-accordion style="margin-bottom: 1%; width: 100%;">
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                {{ 'WIZARD.TIMELINE.STEPS.STEP01' | translate}} {{ 'WIZARD.TIMELINE.STEPS.STEP02' | translate}}
                            </mat-panel-title>

                        </mat-expansion-panel-header>
                        <table class="redTable" style="width: 100%;">
                            <thead style="background: #F20505;">
                                <tr>
                                    <th style="width: 10%;">{{ 'WIZARD.TIMELINE.TABLE.LABEL01' | translate}}</th>
                                    <th style="width: 65%;">{{ 'WIZARD.TIMELINE.TABLE.LABEL02' | translate}}</th>
                                    <th style="width: 25%;">{{ 'WIZARD.TIMELINE.TABLE.LABEL03' | translate}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let et1 of etapa1">
                                    <td style="font-size: 13px; padding-left: 7px;">{{et1.requisito}}</td>
                                    <td style="font-size: 13px; padding-left: 7px;">{{et1.actividad | translate }}</td>
                                    <td style="font-size: 13px; ">{{et1.entregable | translate}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
            <div fxFlex="50" class="" style="padding-top: 1%;">
                <mat-accordion style="padding-top: 5%; width: 100px;">
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                {{ 'WIZARD.TIMELINE.STEPS.STEP03' | translate}} {{ 'WIZARD.TIMELINE.STEPS.STEP04' | translate}}
                            </mat-panel-title>

                        </mat-expansion-panel-header>
                        <table class="redTable" style="width: 100%;">
                            <thead style="background: #F20505;">
                                <tr>
                                    <th style="width: 15%;">{{ 'WIZARD.TIMELINE.TABLE.LABEL01' | translate}}</th>
                                    <th style="width: 60%;">{{ 'WIZARD.TIMELINE.TABLE.LABEL02' | translate}}</th>
                                    <th style="width: 25%;">{{ 'WIZARD.TIMELINE.TABLE.LABEL03' | translate}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let et2 of etapa2">
                                    <td style="font-size: 13px;">{{ et2.requisito}}</td>
                                    <td style="font-size: 13px;">{{ et2.actividad | translate}}</td>
                                    <td style="font-size: 13px;">{{ et2.entregable | translate}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>



    </div><br><br>

</div>
<!-- / CENTER -->